import { render } from "./ZhaiHead.vue?vue&type=template&id=20f589bc&scoped=true"
import script from "./ZhaiHead.vue?vue&type=script&lang=js"
export * from "./ZhaiHead.vue?vue&type=script&lang=js"

import "./ZhaiHead.vue?vue&type=style&index=0&id=20f589bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f589bc"]])

export default __exports__